<template>
  <div class="release-quotation-wrap">
    <header-title title="发布报价"></header-title>
    <div class="form-wrap">
      <el-row>
        <el-form label-width="120px">
          <el-col :span="8">
            <el-form-item label="品种" required>
              <el-select class="rule" v-model="create.variety" placeholder="请选择品种" @change="selectVariety">
                <el-option
                  v-for="(item, index) in varietyList"
                  :key="index"
                  :label="item.dictSubValue"
                  :value="item.dictSubCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <category
              :category="create.categoryCode"
              :code="code"
              v-model="create.categoryCode"
              @countDeposit="countDeposit"
              ref="resetCategory" />
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌" required>
              <el-select class="rule" filterable v-model="create.brandCode" placeholder="请选择，输入品牌可搜索">
                <el-option :label="item.selName" v-for="item in brandList" :key="item.selId" :value="item.selCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="等级" required>
              <el-select class="rule" v-model="create.gradeCode" placeholder="请选择等级">
                <el-option :label="item.name" v-for="(item, index) in this.$key.releaseQuotation.grade" :key="index" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产地" required class="region-box">
              <region
                :isHaveArea="false"
                :regionInfo="regionInfo"
                :needChangeSort="true"
                :operateId="'origin'"
                @returnRegion="returnRegion"
                ref="callRegion" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="榨季" required>
              <el-select class="rule" v-model="create.season" placeholder="请选择榨季">
                <el-option :label="item.selName" v-for="item in seasonList" :key="item.selId" :value="item.selName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="升贴水单价" required>
              <el-input
                class="rule"
                v-model="create.liftingWater"
                maxlength="10"
                placeholder="请输入升贴水单价"
                @blur="numberFormat" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <contract
              v-model="create.contract"
              :contractCode="create.contract"
              ref="resetData"
              @getFirstContract="getFirstContract"
              @returnContract="returnContract" />
          </el-col>
          <el-col :span="8">
            <el-form-item class="rule" label="可交货时间" required>
              <el-date-picker
                v-model="create.deliveryDate"
                type="date"
                @change="checkDate"
                :picker-options="pickerOptions"
                placeholder="选择可交货时间" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可销售数量" required>
              <el-input
                v-model="create.saleableQuantity"
                maxlength="10"
                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                class="haveUnit"
                placeholder="请输入可销售数量"
                @input="countDeposit" />
              <span class="unit">吨</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最少摘牌" required>
              <el-input
                v-model="create.minQuantity"
                maxlength="10"
                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                class="haveUnit"
                placeholder="请输入最少摘牌" />
              <span class="unit">吨</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交货地" required>
              <region
                placeholder="选择"
                :regionInfo="goodsAreaInfo"
                :needChangeSort="true"
                operateId="goods"
                @returnRegion="returnRegion"
                ref="callRegion" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交货方式" required>
              <el-select class="rule" v-model="create.deliveryType" placeholder="请选择交货方式">
                <el-option :label="item.name" v-for="(item, index) in this.$key.releaseQuotation.deliveryType" :key="index" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库名">
              <el-select class="rule" v-model="create.whId" placeholder="请选择，如无请填仓库备注" filterable remote :remote-method="queryWh">
                <el-option :label="item.whName" v-for="item in whList" :key="item.id" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库备注">
              <el-input  class="rule" v-model="create.wareHouseAddress" placeholder="请输入仓库名称或地址" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="rule" label="仓租费起始日" required>
              <el-date-picker
                v-model="create.warehouseRentStartDate"
                type="date"
                :picker-options="pickerOptions"
                placeholder="选择仓租费起始日" />
            </el-form-item>
          </el-col>
          <el-col :span="16"  class="loanRequire-box">
            <el-form-item label="货款要求" required>
              <el-date-picker
                v-model="create.loanRequire"
                class="haveUnit"
                type="date"
                @change="checkDate"
                :picker-options="pickerOptions"
                placeholder="请选择" />
              <span class="unit">前支付</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="指定报价群组">
              <el-select class="rule" v-model="create.groupId" placeholder="请选择群组">
                <el-option v-for="(item, index) in groupList"
                           :key="index"
                           :label="item.groupName"
                           :value="item.groupId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否自动下架">
              <el-select class="rule" v-model="create.autoCancel" placeholder="请选择是否自动下架">
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="create.autoCancel === 'Y'">
            <el-form-item label="报价下架时间" class="rule-date" required>
              <el-date-picker
                v-model="create.soldOutDate"
                type="date"
                :picker-options="pickerOptions"
                placeholder="下架日期" />
              <el-time-select
                class="sold-out-time"
                v-model="create.soldOutTime"
                :picker-options="{
                   start: '00:00',
                   step: '00:30',
                   end: '23:30'
                }"
                placeholder="时间" />
            </el-form-item>
          </el-col>
          <el-col :span="24"></el-col>
          <el-col :span="16">
            <el-form-item label="报价备注">
              <el-input v-model="create.remark" placeholder="请输入报价备注" maxlength="20" style="width: 92%;" />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div class="warning-tip" v-if="freezingQuantity && thawedQuantity && Number(create.saleableQuantity) > 0">
        发布报价冻结挂牌商品履约金{{ freezingQuantity }}元，当前账户可用挂牌商品履约金{{ thawedQuantity }}元
      </div>
    </div>
    <div class="button-wrap over">
      <el-button type="primary plain back-button" @click="back" v-if="$route.params.quotationId !== '0'">返回</el-button>
      <el-button class="left-button plain" @click="reset" v-if="(qualificationType === 'ALL' || qualificationType === 'S') && !isEdit">重置</el-button>
      <el-button type="primary" @click="release" v-if="!isEdit" :disabled="!(qualificationType === 'ALL' || qualificationType === 'S')" :loading="loading">保存</el-button>
      <el-button type="primary" @click="release" v-if="isEdit" :loading="loading">确认发布</el-button>
    </div>
    <div class="warning-tip" v-if="!isLogin">提示：登录后才可发布报价</div>
    <div class="warning-tip" v-if="isLogin && (qualificationType === 'B' || qualificationType === '')">提示：您尚未开通发布报价权限，请联系客服4006230066</div>
    <div class="empty-box"></div>
  </div>
</template>

<script>
import region from '@/components/Region'
import contract from './components/contract'
import category from './components/category'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('framework')

function Create () {
  this.marketId = '000' // 市场（本个版本写死为白糖的市场编码）
  this.variety = '' // 品种
  this.brandName = '' // 品牌
  this.brandCode = '' // 品牌Code
  this.categoryCode = '' // 品类
  this.gradeCode = 'YIJ' // 等级
  this.origin = '' // 产地
  this.season = '19/20' // 榨季
  this.liftingWater = '' // 升贴水
  this.contract = '' // 最后定价合约
  this.deliveryDate = '' // 可交货时间
  this.saleableQuantity = '' // 可交易数量
  this.minQuantity = '' // 最小交易数量
  this.provinceId = '' // 省id
  this.cityId = '' // 市id
  this.areaId = '' // 区id
  this.addressStr = '' // 交货地址
  this.anonymity = 'Y' // 是否匿名
  this.deliveryType = '10' // 交货方式
  this.wareHouseAddress = '' // 仓库名
  this.id = '' // 编辑报价时候的id
  this.originProvinceId = '' // 产地省id
  this.originCityId = '' // 产地市id
  this.warehouseRentStartDate = '' // 仓租费起始日
  this.loanRequire = '' // 货款要求：**天内支付
  this.spanMonthContango = '' // 是否跨月
  this.autoCancel = 'N' // 是否自动下架
  this.soldOutDate = '' // 下架日期
  this.soldOutTime = '15:00' // 下架时间
  this.autoCancelDate = '' // 下架的完整日期时间
  this.groupId = '' // 群组id
  this.whName = '' // 仓库名称
  this.whId = '' // 仓库id
  this.whCode = '' // 仓库code
}
function Region () {
  this.provinceId = ''
  this.cityId = ''
  this.areaId = ''
}

export default {
  name: 'ReleaseQuotation',
  components: {
    region,
    contract,
    category
  },
  data () {
    return {
      create: new Create(), // 报价信息
      isEdit: false, // 是否是编辑模式
      // 检验规则
      createRules: [
        { name: 'variety', message: '请选择品种' },
        { name: 'categoryCode', message: '请选择品类' },
        { name: 'brandCode', message: '请填写品牌' },
        { name: 'gradeCode', message: '请选择等级' },
        { name: 'origin', message: '请选择产地（需包含省和市）' },
        { name: 'season', message: '请选择榨季' },
        { name: 'contract', message: '请选择购销计划' },
        { name: 'deliveryDate', message: '请选择可交货时间' },
        { name: 'saleableQuantity', message: '请填写可销售数量' },
        { name: 'minQuantity', message: '请填写最小摘牌' },
        { name: 'provinceId', message: '请填写交货地（需包含省市）' },
        { name: 'cityId', message: '请填写交货地（需包含省市）' },
        { name: 'deliveryType', message: '请选择交货方式' },
        { name: 'anonymity', message: '请选择是否匿名' },
        { name: 'warehouseRentStartDate', message: '请选择仓租费起始日' },
        { name: 'loanRequire', message: '请选择货款要求的支付期限日期' }
      ],
      pickerOptions: { // 时间选择控件的配置项
        start: '15:00',
        step: '00:30',
        end: '23:30',
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7 // 将当前日期之前的日期作为禁用日期
        }
      },
      contractDate: '', // 购销计划对应的时间
      firstContract: '', // 首个购销计划
      varietyList: [], // 品种列表
      brandList: [], // 品牌列表
      gradeList: [], // 等级列表
      seasonList: [], // 榨季列表
      whList: [], // 仓库列表
      code: '', // 选择的品种的code值
      categoryList: [], // 品类列表
      sellerDepositObj: {}, // 挂牌商品履约金对象
      freezingQuantity: '', // 冻结货款
      thawedQuantity: '', // 未冻结货款
      regionInfo: new Region(), // 产地信息
      goodsAreaInfo: new Region(), // 交货地信息
      groupList: [], // 群组数组
      sellerDepositRate: 1, // 履约金比例
      loading: false
    }
  },
  computed: {
    ...mapState({
      qualificationType: 'qualificationType',
      isLogin: 'isLogin',
    }),
  },
  watch: {
    '$route' () {
      this.reset()
    },
    create: {
      handler () {
        this.countDeposit()
      },
      deep: true
    },
    sellerDepositRate () {
      this.countDeposit()
    }
  },
  mounted () {
    if (this.$route.params.id) { // 有id的是是编辑报价，先请求详情数据
      this.getDetails(this.$route.params.id) // 获取详情数据
      this.isEdit = true
      this.create.id = this.$route.params.id
    }
    // 如果存在quotationId且不为0，那么代表是重新发布，请求数据填充进去即可
    if (this.$route.params.quotationId && String(this.$route.params.quotationId) !== '0') {
      this.getDetails(this.$route.params.quotationId)
    }
    this.getSellerDeposit() // 获取挂牌商品履约金
    this.getFreezingQuantity() // 获取未冻结余额
    this.getVariety() // 获取品种列表
    this.getUserGroupList() // 获取群组列表
    this.queryGroupItemListByCode() // 获取商品属性
    if (String(this.$route.query.quotationId) === '0') {
      this.queryWh() // 获取仓库
    }
  },
  methods: {
    // 获取报价详情
    getDetails (id) {
      const url = this.$API.MyQuotation.detailContango
      const param = {
        id: id
      }
      this.$http.post(url, param).then(res => {
        this.create = this.$utils.objectAssign({}, this.create, res.data)
        if (this.create.autoCancel === 'Y') { // 自动下架填充对应的日期和时间
          this.create.soldOutDate = this.create.autoCancelDate.substr(0, 10)
          this.create.soldOutTime = this.create.autoCancelDate.substr(11, 5)
        }
        this.code = this.create.variety // 填充品种品类
        // 填充产地和交货地的信息
        this.goodsAreaInfo = {
          provinceId: this.create.provinceId,
          cityId: this.create.cityId,
          areaId: this.create.areaId
        }
        this.regionInfo = {
          provinceId: this.create.originProvinceId,
          cityId: this.create.originCityId
        }
        this.create.whId = this.create.whId ? Number(this.create.whId) : '' // 把仓库id处理成数字类型
        this.queryWh(this.create.whName)
        setTimeout(() => {
          this.countDeposit()
        }, 100)
      })
    },
    // 获取未冻结余额
    getFreezingQuantity () {
      const url = this.$API.releaseQuotation.queryUserErpAccount
      this.$http.post(url, {}).then(res => {
        this.thawedQuantity = res.data.amount
        this.sellerDepositRate = res.data.sellerDepositRate
      })
    },
    // 获取挂牌商品履约金对象
    getSellerDeposit () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: 'ContangoSellerDeposit',
        dictStatus: '1',
        pageSize: 50
      }
      // 根据查询的挂牌商品履约金列表，得到对应的挂牌商品履约金对象
      this.$http.post(url, param).then((res) => {
        res.data.rows.forEach((item) => {
          this.sellerDepositObj[item.dictSubCode] = item.dictSubValue
        })
      })
    },
    // 获取仓库
    queryWh (whName = '') {
      const url = this.$API.releaseQuotation.queryWh
      const param = {
        currentNo: 1,
        pageSize: 499,
        marketCode: '000',
        whName: whName
      }
      this.$http.post(url, param).then(res => {
        this.whList = res.data.rows || []
      })
    },
    // 获取商品属性
    queryGroupItemListByCode () {
      const url = this.$API.releaseQuotation.queryGroupItemListByCode
      const param = {
        code: '101000'
      }
      this.$http.post(url, param).then((res) => {
        this.brandList = this.getListByCode(res.data, 'brand') // 品牌列表
        this.gradeList = this.getListByCode(res.data, 'grade') // 等级列表
        this.seasonList = this.getListByCode(res.data, 'crushingSeason') // 榨季列表
      })
    },
    // 从属性列表中找到对应属性
    getListByCode (list, code) {
      const paramObj = list.find(item => item.itemCode === code)
      return paramObj.itemSel
    },
    // 获取品种
    getVariety () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: 'ContangoVarietyList',
        dictStatus: '1',
        pageSize: 50
      }
      this.$http.post(url, param).then((res) => {
        this.varietyList = res.data.rows
      })
    },
    // 获取群组列表
    getUserGroupList () {
      const url = this.$API.customer.getUserGroupList
      this.$http.post(url, {}).then(res => {
        this.groupList = res.data
      })
    },
    // 选择品种
    selectVariety (val) {
      this.create.categoryCode = ''
      this.code = val
    },
    // 数字格式化提示
    numberFormat () {
      const integerReg = /^-?[0-9]\d*$/ // 是否整数
      if (this.create.liftingWater && !integerReg.test(this.create.liftingWater)) {
        this.$message.error('升贴水单价应为整数')
      }
    },
    // 计算冻结货款
    countDeposit () {
      const needNotGradeCategory = ['ContangoCategoryCST', 'ContangoCategoryHT', 'ContangoCategoryBPT', 'ContangoCategoryPT'] // 不需要等级的品种
      if (this.create.categoryCode && this.create.saleableQuantity && this.create.gradeCode &&
        this.create.contract && Number(this.create.saleableQuantity) > 0) {
        const spacing = 'DY'
        this.create.spanMonthContango = 'N' // 后台需要(暂时写死，紧急修复问题)
        /**
         * code用来查询挂牌商品履约金，由品类，月份跨度标识，等级拼接而成，分为两类
         * needNotGradeCategory这个数组中的品种不需要拼接上等级，不在这个数组的需要在后面拼接上等级
         * **/
        let code = needNotGradeCategory.includes(this.create.variety) ? `${this.create.categoryCode}_${spacing}` : `${this.create.categoryCode}_${spacing}_${this.create.gradeCode}`
        this.freezingQuantity = Number(this.sellerDepositObj[code]) * Number(this.create.saleableQuantity) * this.sellerDepositRate // 计算冻结货款
      } else {
        this.freezingQuantity = '' // 信息填写不完整就把冻结货款重置为空
      }
    },
    // 购销计划选择返回信息
    returnContract (contract, contractDate) {
      this.create.contract = contract
      this.contractDate = contractDate
    },
    // 获取首个购销计划
    getFirstContract (contract) {
      this.firstContract = contract
    },
    // 地区选择信息返回信息
    returnRegion (data) {
      if (data.operateId === 'origin') { // 返回的是产地的信息
        this.create.originProvinceId = data.provinceId
        this.create.originCityId = data.cityId || ''
        // 如果返回的信息包含省市，则赋值，否则，将值清空
        this.create.origin = (data.provinceName && data.cityName) ? (data.provinceName + data.cityName) : ''
      }
      if (data.operateId === 'goods') { // 返回的是提货地的信息
        this.create.provinceId = data.provinceId
        this.create.cityId = data.cityId || ''
        this.create.areaId = data.areaId || ''
        this.create.addressStr = data.provinceName + (data.cityName || '') + (data.areaName || '')
      }
    },
    // 重置
    reset () {
      this.create = new Create()
      this.freezingQuantity = ''
      this.contractDate = ''
      this.regionInfo = new Region()
      this.goodsAreaInfo = new Region()
      this.$refs.resetData.reset()
      this.$refs.resetCategory.reset()
      this.getFreezingQuantity() // 获取未冻结余额
    },
    checkDate () {
      // 格式化已选择的可交货时间，需要的格式是类似于‘20190830’
      const formatDate = this.$utils.changeFormatTime(this, this.create.deliveryDate).substr(0, 10).replace(/-/g, '')
      /**
       将合约最后交货时间由20190830’这种格式转化为‘2019-08-30’这种格式
       然后，算出转化后的日期的后3天的日期
       **/
      const tipDate = this.$utils.addDate(this.$utils.getStringDate(this.contractDate), 3)
      const lastDeliveryDate = tipDate.substr(0, 10).replace(/-/g, '') // 交货的最晚日期（格式是类似于‘20190830’）
      // 如果购销计划存在，则比较可交货时间和合约最后交货时间的大小关系
      if (this.create.contract && tipDate && Number(formatDate) > Number(lastDeliveryDate)) {
        this.$message.error('可交货时间不能大于购销计划最后交货时间' + tipDate)
        return false
      } else {
        return true
      }
    },
    // 校验
    check () {
      const numReg = /(^[1-9]([0-9]*)$|^[0-9]$)/ // 首位不为0的数字
      const integerReg = /^-?[0-9]\d*$/ // 是否整数
      if (!numReg.test(this.create.saleableQuantity)) {
        this.$message.error('可销售数量应为大于0的整数')
        return false
      } else if (!integerReg.test(this.create.liftingWater)) {
        this.$message.error('升贴水单价应为整数')
        return false
      } else if (!this.checkDate()) {
        return false
      } else if (!numReg.test(this.create.minQuantity)) {
        this.$message.error('最少摘牌应为大于0的整数')
        return false
      } else if (Number(this.create.saleableQuantity) < Number(this.create.minQuantity)) {
        this.$message.error('最少摘牌不能大于可销售数量')
        return false
      } else if (Date.parse(this.create.warehouseRentStartDate) < Date.parse(this.create.deliveryDate)) {
        this.$message.error('仓租费起始日不能小于可交货时间')
        return false
      } else if (this.create.autoCancel === 'Y' && (!this.create.soldOutDate || !this.create.soldOutTime)) {
        this.$message.error('请选择报价下架时间')
      } else if (this.create.autoCancel === 'Y' && (Date.parse(this.create.autoCancelDate) <= Date.parse(new Date()))) {
        this.$message.error('报价下架时间要大于当前时间')
        return false
      } else {
        return true
      }
    },
    // 根据code值获取名字
    getNameByCode (list, code) {
      const obj = list.find(item => item.selCode === code)
      return obj.selName
    },
    // 获取仓库数据
    getWhData () {
      const whObj = this.whList.find(item => item.id === this.create.whId)
      if (whObj && whObj.whName) {
        this.create.whName = whObj.whName // 仓库名称
        this.create.whCode = whObj.whCode // 仓库code
      }
    },
    // 发布
    release () {
      this.create.deliveryDate = this.$utils.changeFormatTime(this, this.create.deliveryDate).substr(0, 10) // 格式化可交货时间
      this.create.warehouseRentStartDate = this.$utils.changeFormatTime(this, this.create.warehouseRentStartDate).substr(0, 10) // 格式化仓租费起始日
      this.create.loanRequire = this.$utils.changeFormatTime(this, this.create.loanRequire).substr(0, 10) // 格式化货款支付期限日期
      // 选择了自动下架，拼接选择的的下架日期和时间
      if (this.create.autoCancel === 'Y' && this.create.soldOutDate && this.create.soldOutTime) {
        this.create.autoCancelDate = `${this.$utils.changeFormatTime(this, this.create.soldOutDate).substr(0, 10)} ${this.create.soldOutTime}`
      }
      if (!this.$utils.checkEmptyRules(this.create, this.createRules) && this.check()) {
        this.create.spanMonthContango = 'N' // 后台需要(暂时写死，紧急修复问题)
        this.create.brandName = this.getNameByCode(this.brandList, this.create.brandCode) // 获取品牌名称
        if (this.create.whId) { // 如果选择了仓库，则补充完整仓库信息
          this.getWhData() // 获取仓库数据
        }
        this.checkDepositRate()
      }
    },
    // 检查履约金比例是否发生变化
    checkDepositRate () {
      const url = this.$API.releaseQuotation.getPcUserDepositRate
      this.loading = true
      this.$http.post(url, {}).then(res => {
        if (res.data.sellerDepositRate === this.sellerDepositRate) { // 履约金没有发生变化，提交数据
          this.submit()
        } else {
          this.loading = false
          // 履约金发生变化，提示用户
          this.sellerDepositRate = res.data.sellerDepositRate
          this.countDeposit()
          this.$alert('履约金优惠折扣发生变化，请重新确认履约金金额', {
            confirmButtonText: '确定'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 提交数据
    submit () {
      const url = this.isEdit ? this.$API.MyQuotation.releaseMyContango : this.$API.releaseQuotation.addContango
      const tip = this.isEdit ? '发布成功' : '保存成功'
      this.$http.post(url, this.create).then(() => {
        this.$message.success(tip)
        this.reset()
        if (this.isEdit) { // 神策数据收集
          this.$sensors.track('PublishingPrice', { operation: '发布报价', publish: '发布' }) // 发布
        } else {
          this.$sensors.track('SubmitPurchaseOrder', { operation: '提交报价', quotation_data: this.create }) // 保存
        }
        this.loading = false
        // 跳转我的报价页，后面的status代表状态，用来我的报价页面tab栏初始显示用
        this.$router.push({ path: `/framework/myTrading/myQuotation?status=${this.isEdit ? 1 : 3}` })
      }).catch(() => {
        this.loading = false
      })
    },
    // 返回上一页
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .release-quotation-wrap{
    margin-top: 16px !important;
    .form-wrap{
      margin-top: 40px;
      padding-bottom: 25px;
      border-bottom: 1px solid #e8e8e8;
      /deep/ .rule .el-input__inner{
        width: 224px;
      }
      /deep/ .haveUnit{
        width: 200px;
        margin-right: 10px;
      }
      /deep/ .haveUnit .el-input__inner{
        width: 200px;
      }
      /deep/ .loanRequire{
        width: 153px;
        margin-right: 15px;
      }
      /deep/ .sold-out-time{
        margin-left: 8px;
      }
    }
    .button-wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-top: 62px;
        margin-bottom: 20px;
      }
      .left-button{
        margin-right: 32px;
      }
      .back-button{
        margin-right: 32px;
      }
    }
    /deep/ .rule-date{
      .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 140px;
      }
      .sold-out-time{
        width: 110px !important;
      }
    }
    /deep/ .region-box{
      .el-row{
        width: 235px;
      }
    }
    /deep/ .loanRequire-box{
      .haveUnit{
        width: 172px !important;
      }
      .el-input__inner{
        width: 172px !important;
      }
    }
  }
</style>
